import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { ItemCardWithCopyNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardWithCopyNo/ItemCardWithCopyNo";
import { useTranslation } from "@coworker/locales";
import ModalColumn from "../ModalColumn/ModalColumn";
import styles from "./TitledArticleCard.module.css";

type TitledArticleCardProps = {
  title?: string;
  item: Item;
  className?: string;
};

function TitledArticleCard({ title, item, className }: TitledArticleCardProps) {
  const { t } = useTranslation();

  return (
    <ModalColumn gap="small" className={className}>
      {title && (
        <FixaText textStyle="Heading.S" tagName="h2">
          {t(title)}
        </FixaText>
      )}
      <div className={styles["card"]}>
        <ItemCardWithCopyNo item={item} />
      </div>
    </ModalColumn>
  );
}

export default TitledArticleCard;
